import ApiRouteProvider, {objectToGETParams} from '../route'
import axios from '@axios'
import Cache from "@core/api/request/Cache";
import store from "@/store"

store.watch(
    (state) => {
        return state.user.organization;
    },
    () => {
        Cache.invalidate('LegislationList');
    }
)

store.watch(
    (state) => {
        return state.user.rootOrganizationState;
    },
    () => {
        Cache.invalidate('LegislationList');
    }
)

export default {
    all() {
        return Cache.item('LegislationList', () => {
            return axios.get(ApiRouteProvider.legislation.all());
        }).getPromise();
    },

    get(filters, sorting, page, perPage) {
        return axios.get(ApiRouteProvider.legislation.get({
            filters,
            sort: sorting,
            page,
            perPage
        }))
    },

    grid(filters, sorting, page, perPage) {
        return axios.get(ApiRouteProvider.getBaseUrl() + '/legislations/grid?' + objectToGETParams({
            filters,
            sort: sorting,
            page,
            perPage
        }));
    },

    getTranslations() {
        return Cache.item('LegislationVerificationDocumentTypes', () => {
            return axios.get(ApiRouteProvider.getBaseUrl() + '/legislations/translations');
        }).getPromise();
    },

    card(id) {
        return axios.get(ApiRouteProvider.legislation.card(id));
    },

    createLegislation(legislation) {
        return axios.post(ApiRouteProvider.getBaseUrl() + '/legislations', legislation);
    },

    updateLegislation(id, legislation) {
        return axios.put(ApiRouteProvider.getBaseUrl() + '/legislations/' + id, legislation);
    },

    getQuestionGroups(filters, sorting, page, perPage) {
        return axios.get(ApiRouteProvider.legislation.questionGroups({
            filters,
            sort: sorting,
            page,
            perPage
        }));
    },

    getQuestionGroup(id) {
        return axios.get(ApiRouteProvider.legislation.questionGroup(id));
    },

    createQuestionGroup(questionGroup) {
        return axios.post(ApiRouteProvider.legislation.questionGroups({}), questionGroup);
    },

    updateQuestionGroup(id, questionGroup) {
        return axios.put(ApiRouteProvider.legislation.questionGroup(id), questionGroup);
    },

    getQuestionCatalog(context = null) {
        return axios.get(ApiRouteProvider.legislation.questionCatalog({context}));
    },

    getQuestionnaire(legislationIds, scope = null) {
        return axios.get(ApiRouteProvider.legislation.questionnaire({legislationIds, scope}));
    },

    getEvidenceReportTypes() {
        return Cache.item('LegislationEvidenceReportTypes', () => {
            return axios.get(ApiRouteProvider.legislation.getEvidenceReportTypes());
        }).getPromise();
    },

    getVerificationDocumentTypes() {
        return Cache.item('LegislationVerificationDocumentTypes', () => {
            return axios.get(ApiRouteProvider.legislation.getVerificationDocumentTypes());
        }).getPromise();
    },

    getLegislationStatuses(id) {
        return axios.get(ApiRouteProvider.legislation.legislationStatuses(id));
    },

    getProductStatuses() {
        return Cache.item('LegislationProductStatuses', () => {
            return axios.get(ApiRouteProvider.getBaseUrl() + '/legislations/statuses');
        }).getPromise();
    },

    getProductEvents() {
        return Cache.item('LegislationProductEvents', () => {
            return axios.get(ApiRouteProvider.getBaseUrl() + '/legislations/events');
        }).getPromise();
    },

    getExpressionLanguageExplanation() {
        return Cache.item('LegislationExpLangExplain', () => {
            return axios.get(ApiRouteProvider.getBaseUrl() + '/legislations/expression-language/explanation')
        }).getPromise();
    }
};
